import type { DatasetFile, DatasetImage } from "@/entities/dataset";

export const getDatasetDownloadFileUrl = (
  dataset: DatasetImage | DatasetFile
) => {
  switch (dataset.type) {
    case "image":
      return dataset.data_download_path ?? dataset.data_path;
    case "file":
      return dataset.data_path;
    default:
      return undefined;
  }
};
